export default {
  established: 'Established',
  probable: 'Probable',
  suspected: 'Suspected',
  possible: 'Possible',
  unknown: 'Doubtful/Unknown',
};
